// @flow
import React, {Fragment} from 'react';
import { MdEvent } from 'react-icons/lib/md';
import styles from './stopCard.css';
import Button from '../../Button';
import StudentSchedulingPopup from '../../StudentSchedulingPopup';
import Popup from "../../Popup";

type StopCardPropTypes = {
  name: string,
  type: string,
  openScheduleAction: Function,
  studentId: number,
};

const StopCard = ({
  name = '',
  studentId,
  openScheduleAction,
  type = 'going',
}: StopCardPropTypes) => (
  <div className={styles.stopCard}>
    <div className={styles.textContainer}>
      <h2 className={styles.title}>
        { name }
      </h2>
      <h3 className={styles.subtitle}>{ type === 'going' ? 'Recolección' : 'Entrega'}</h3>
    </div>
    <div className={styles.iconContainer}>
      <Popup
        id={`routesCalendar${studentId}`}
        theme="main"
        transitionType="slideDown"
        transitionMs={600}
      >
        <StudentSchedulingPopup studentId={studentId} />
      </Popup>
      <Button
        Icon={MdEvent}
        isOutlined
        className={styles.icon}
        onClick={() => openScheduleAction()}
        isTransparent
        size="medium"
        tint="mediumGray"
      />
    </div>
  </div>
);

export default StopCard;



// WEBPACK FOOTER //
// ./src/scripts/components/StudentCard/StopCard/index.jsx